import { Model } from "./model";

//import { Posm } from "./posm.model";

export class PosmCategory extends Model {
    id: number;
    name: string;
    title?: string;
    content?: string;
    image?: string;
    translation?: string;
    link_to: string;
}


// WEBPACK FOOTER //
// ./src/models/posm-category.model.ts